import type { MagentoApiGetAvailablePaymentMethodsQueryResponse } from "@jti/magento-api-v2";
import type { MagentoPaymentMethod } from "@jti/magento-types";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

export const getAvailablePaymentMethodsEndpoint = (builder: MagentoApiBuilder) => ({
  getAvailablePaymentMethods: builder.query<MagentoPaymentMethod[], string>({
    query: (cartId) => ({
      method: "getAvailablePaymentMethods",
      params: [{ cartId }],
    }),
    providesTags: [TAGS.AVAILABLE_PAYMENT_METHODS],
    transformResponse: (response: MagentoApiGetAvailablePaymentMethodsQueryResponse): MagentoPaymentMethod[] =>
      (response.cart?.available_payment_methods ?? [])
        .filter((method): method is NonNullable<typeof method> => method !== null)
        .map(({ code, title }) => ({ code, title })),
  }),
});
